import React from 'react';

import { useState, useEffect } from 'react';
import { IOccupancyFilter, EStatisticsGraphView, EStatisticsInterval, EStatisticsType } from '../../../../../reducers/data';
import getOccupancy from '../../../../../reducers/api/getOccupancy';
import Loader from '../../Loader';
import { useLingui } from '@lingui/react';
import { IGraphContentData, IGraphData } from '../../../../interfaces/types';
import XYGraph from './XYGraph';
import OccupancyTableGraph from './OccupancyTableGraph';

import { parseGraphData, parseGraphDataOverlay } from '../../../../helpers/index';
import { t, Trans } from '@lingui/macro';


interface IProps {
    filter: IOccupancyFilter
}

const GraphOccupancy = (props: IProps) => {
    const lingui = useLingui()

    const [loading, setLoading] = useState(false)
    const [rawResults, setRawResults] = useState<IGraphData[]|undefined>()
    const [graphResults, setGraphResults] = useState<IGraphData[]|undefined>()
    const [overlayMode, setOverlayMode] = useState(false)
    const [graphData, setGraphData] = useState<IGraphContentData>({
        series: [],
        categories: []
    })
    
    useEffect(() => {
        setLoading(true)
        let isMounted = true

        getOccupancy({
            ...props.filter,
            graphView: props.filter.type === EStatisticsType.table ? EStatisticsGraphView.zone : props.filter.graphView
        })
            .then(res => {
                if(isMounted) {
                    setLoading(false)
                    setRawResults(res)
                    setGraphResults(res)
                }
            })
            .catch(e => {
                if(isMounted) {
                    setLoading(false)
                    setRawResults(undefined)
                    setGraphResults(undefined)
                    setGraphData({ series: [], categories: [] })
                }
            })
        return () => { isMounted = false }
    }, [props.filter])

    useEffect(() => {
        if (overlayMode && rawResults) {
            setGraphData(parseGraphDataOverlay(rawResults, lingui.i18n))
        } else {
            setGraphData(parseGraphData(rawResults ? rawResults : [], lingui.i18n))
        }
    }, [rawResults, overlayMode, lingui.i18n])

    let graphTitle = t`Multi`
    let graphInterval = EStatisticsInterval.min15;

    if(props.filter.graphView === EStatisticsGraphView.date) {
        graphTitle = t`Dátum`
    } else if (props.filter.graphView === EStatisticsGraphView.zone) {
        graphTitle = t`Zóna`
    }
    let isTime = false;
    let yTitle =  t`Počet návštevníkov`

    let dataToSend: {
        date: {
            from: string,
            to: string
        }[],
        interval?: EStatisticsInterval,
        zones?: number[],
        group?: EStatisticsGraphView
    } = {
        date: props.filter.dateRanges,
        interval: graphInterval,
        zones: props.filter.zones,
        group: props.filter.graphView
    }

    let objJsonStr = JSON.stringify(dataToSend);
    let objJsonB64 = Buffer.from(objJsonStr).toString("base64");

    // In overlay mode force HH:mm X axis
    const effectiveInterval = overlayMode ? EStatisticsInterval.min60 : graphInterval

    return (
        <>
            <Loader value={loading}/>
            {(props.filter.type === EStatisticsType.xy) && (
                <>
                    <div className="grid align-center pdb-10">
                        <div className="col_fill" />
                        <div className="col_default">
                            <div className="btn_switch" role="group" aria-label={t`Režim zobrazenia`}>
                                <button
                                    type="button"
                                    className={`btn_switch--item${!overlayMode ? ' active' : ''}`}
                                    onClick={() => setOverlayMode(false)}
                                    title={t`Sériový režim – dni za sebou`}
                                >
                                    <Trans>Séria</Trans>
                                </button>
                                <button
                                    type="button"
                                    className={`btn_switch--item${overlayMode ? ' active' : ''}`}
                                    onClick={() => setOverlayMode(true)}
                                    title={t`Prekryvný režim – dni na rovnakej osi`}
                                >
                                    <Trans>Prekryv</Trans>
                                </button>
                            </div>
                        </div>
                    </div>
                    <XYGraph graphTitle={graphTitle} graphData={graphData} interval={effectiveInterval} isTime={isTime} yTitle={yTitle} overlayMode={overlayMode} />
                </>
            )}
            {(props.filter.type === EStatisticsType.table) && (
                <OccupancyTableGraph graphResults={graphResults} filter={objJsonB64} interval={graphInterval}/>
            )}
        </>
    )
};

export default GraphOccupancy
